





































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { EditorialProject } from '@/models'

@Component
export default class Repository extends Vue {
  private projects: Array<EditorialProject> = []

  created() {
    ApiClient.getEditorialProjects()
      .then(projects => {
        this.projects = projects
      })
      .catch(err => {
        console.error('Error getProjects: ' + err)
      })
  }
}
